if (!customElements.get('custom-country-detector')) {
  customElements.define(
    'custom-country-detector',
    class CustomCountryDetector extends HTMLElement {
      connectedCallback() {
        this.initDOMElements();
        this.defaultEmoji = '📦';
        this.messageTemplate = this.dataset.messageTemplate?.trim() || '';
        this.fetchLocationInfo();
      }

      disconnectedCallback() {
        if (this.abortController) {
          this.abortController.abort();
        }
      }

    initDOMElements() {
      this.element = this.querySelector('.country-detector__message');
    }

    getCountryFlag(countryCode) {
      const flags = new Map([
        ['US', '🇺🇸'],
        ['CA', '🇨🇦'],
        ['FR', '🇫🇷'],
        ['NL', '🇳🇱'],
        ['DE', '🇩🇪'],
        ['GB', '🇬🇧'],
        ['IT', '🇮🇹'],
        ['ES', '🇪🇸'],
        ['CN', '🇨🇳'],
        ['JP', '🇯🇵'],
        ['BR', '🇧🇷'],
        ['IN', '🇮🇳'],
        ['RU', '🇷🇺'],
        ['ZA', '🇿🇦'],
        ['AU', '🇦🇺'],
        ['NZ', '🇳🇿'],
        ['MX', '🇲🇽'],
        ['AR', '🇦🇷'],
        ['CL', '🇨🇱'],
        ['CO', '🇨🇴'],
        ['PE', '🇵🇪'],
        ['VE', '🇻🇪'],
        ['EC', '🇪🇨'],
        ['GT', '🇬🇹'],
        ['HN', '🇭🇳'],
        ['SA', '🇸🇦'],
        ['AE', '🇦🇪'],
        ['TR', '🇹🇷'],
        ['TH', '🇹🇭'],
        ['MY', '🇲🇾'],
        ['SG', '🇸🇬'],
        ['ID', '🇮🇩'],
        ['PH', '🇵🇭'],
        ['VN', '🇻🇳'],
        ['KR', '🇰🇷'],
        ['KP', '🇰🇵'],
        ['SE', '🇸🇪'],
        ['NO', '🇳🇴'],
        ['FI', '🇫🇮'],
        ['DK', '🇩🇰'],
        ['IS', '🇮🇸'],
        ['IE', '🇮🇪'],
        ['CH', '🇨🇭'],
        ['PT', '🇵🇹'],
        ['BE', '🇧🇪'],
        ['LU', '🇱🇺'],
        ['PL', '🇵🇱'],
        ['CZ', '🇨🇿'],
        ['SK', '🇸🇰'],
        ['HU', '🇭🇺'],
        ['AT', '🇦🇹'],
        ['LI', '🇱🇮'],
        ['GR', '🇬🇷'],
        ['BG', '🇧🇬'],
        ['RO', '🇷🇴'],
        ['UA', '🇺🇦'],
        ['BY', '🇧🇾'],
        ['LT', '🇱🇹'],
        ['LV', '🇱🇻'],
        ['EE', '🇪🇪'],
        ['MD', '🇲🇩'],
        ['AM', '🇦🇲'],
        ['GE', '🇬🇪'],
        ['AZ', '🇦🇿'],
        ['IR', '🇮🇷'],
        ['IQ', '🇮🇶'],
        ['SY', '🇸🇾'],
        ['LB', '🇱🇧'],
        ['JO', '🇯🇴'],
        ['IL', '🇮🇱'],
        ['EG', '🇪🇬'],
        ['MA', '🇲🇦'],
        ['DZ', '🇩🇿'],
        ['TN', '🇹🇳'],
        ['LY', '🇱🇾'],
        ['GM', '🇬🇲'],
        ['SN', '🇸🇳'],
        ['MR', '🇲🇷'],
        ['ML', '🇲🇱'],
        ['GN', '🇬🇳'],
        ['CI', '🇨🇮'],
        ['BF', '🇧🇫'],
        ['NE', '🇳🇪'],
        ['TG', '🇹🇬'],
        ['BJ', '🇧🇯'],
        ['NG', '🇳🇬'],
        ['CM', '🇨🇲'],
        ['GA', '🇬🇦'],
        ['CG', '🇨🇬'],
        ['CD', '🇨🇩'],
        ['AO', '🇦🇴'],
        ['GW', '🇬🇼'],
        ['SC', '🇸🇨'],
        ['SD', '🇸🇩'],
        ['RW', '🇷🇼'],
        ['ET', '🇪🇹'],
        ['SO', '🇸🇴'],
        ['DJ', '🇩🇯'],
        ['KE', '🇰🇪'],
        ['TZ', '🇹🇿'],
        ['UG', '🇺🇬'],
        ['BI', '🇧🇮'],
        ['MZ', '🇲🇿'],
        ['ZM', '🇿🇲'],
        ['MW', '🇲🇼'],
        ['LS', '🇱🇸'],
        ['BW', '🇧🇼'],
        ['NA', '🇳🇦'],
        ['SZ', '🇸🇿'],
      ]);

      return flags.get(countryCode?.toUpperCase()) || this.defaultEmoji;
    }

    buildMessage(flag, countryName) {
      const countrySpan = `<span class="shipping-text">${this.sanitizeText(countryName)}</span>`;

      if (!this.messageTemplate) {
        return `${flag} | Free Shipping to ${countrySpan}`;
      }

      const parts = this.messageTemplate.split('[country]');
      let message = `${flag} `;

      for (let index = 0; index < parts.length; index += 1) {
        message += this.sanitizeText(parts[index]);

        if (index < parts.length - 1) {
          message += countrySpan;
        }
      }

      return message;
    }

    setLocationInfo(countryCode, countryName) {
      if (!this.element) {
        console.error('Location info element not found');
        return;
      }

      const flag = this.getCountryFlag(countryCode);
      this.element.innerHTML = this.buildMessage(flag, countryName);
    }

    sanitizeText(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    showError(message = 'Unable to detect location') {
      if (this.element) {
        this.element.innerHTML = `<span class="location-error">${this.defaultEmoji} | ${message}</span>`;
      }
    }

    showLoading() {
      if (this.element) {
        this.element.textContent = 'Detecting location...';
      }
    }

    async fetchLocationInfo() {
      try {
        this.showLoading();

        this.abortController = new AbortController();
        const timeoutId = setTimeout(() => this.abortController.abort(), 5000);

        const response = await fetch('/browsing_context_suggestions.json', {
          signal: this.abortController.signal,
          headers: {
            Accept: 'application/json',
          },
        });

        clearTimeout(timeoutId);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (!data?.detected_values?.country) {
          throw new Error('Invalid response structure');
        }

        const { handle: countryCode, name: countryName } = data.detected_values.country;

        if (!countryName) {
          throw new Error('Country name not found in response');
        }

        this.setLocationInfo(countryCode, countryName);
      } catch (error) {
        console.error('Error fetching location info:', error);

        if (error.name === 'AbortError') {
          this.showError('Location detection timed out');
        } else if (error.message.includes('HTTP error')) {
          this.showError('Unable to detect location');
        } else {
          this.showError();
        }
      }
    }
  },
  );
}
